import React from 'react';

type ExternalLinkCardProps = {
    link: string;
    text: string;
    textLine1?: string;
    target?: string;
};

export function ExternalLinkCard({ link, text, target, textLine1 }: ExternalLinkCardProps) {
    return (
        <div className={'row milan-bg-red milan-text-white text-center'}>
            <a
                href={link}
                target={`${target ? target : '_blank'}`}
                className="d-flex align-items-center justify-content-center w-100"
                style={{ height: '65px' }}
                rel={target === '_blank' ? 'noopener noreferrer' : undefined}
                aria-label={`Already a Client? ${text}`}
            >
                <div className="d-flex flex-column align-items-center">
                    <span>{textLine1}</span>
                    <span className="ps-2">
                        <strong>{text}</strong>
                    </span>
                </div>
            </a>
        </div>
    );
}
